export const exists = (x: unknown): boolean => Boolean(x);

export const defined = (x: unknown): boolean =>
  typeof x !== "undefined" && x !== null;

export const isString = (x: unknown): boolean => typeof x === "string";

export const isNumber = (x: unknown): boolean => typeof x === "number";

export const isArray = (x: unknown): boolean => Array.isArray(x);

export const isObject = (x: unknown): boolean =>
  defined(x) && (x as { constructor: unknown }).constructor === Object;
